import ChargerModule from 'components/chargerModule';
import OrderPriceEditionModule from './OrderPriceEditionModule';
import { useLocation, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { getOrderWithProductPrices } from 'services/priceEdition/orderPriceEdition.service';
import { displayErrorNotification } from 'utils/displayNudosStandardNotifications';
import { IOrderWithProductPrices } from 'types/orders';
import { IProductInfo } from 'types/products';
import { requestOrderSummaryPDF } from 'services/orders';
import './OrderPriceEdition.scss';

const OrderPriceEdition = () => {
  const { state }: { state: { orderData: IOrderWithProductPrices } } = useLocation();
  const { orderId } = useParams<{ orderId: string }>();
  const [orderData, setOrderData] = useState<IOrderWithProductPrices | undefined>();
  const [isLoading, setIsLoading] = useState(true);

  /**
   * Obtiene el PDF del resumen de la orden y actualiza el estado de la orden con el PDF.
   * @param orderId - ID de la orden para la cual se obtendrá el PDF
   */
  const loadOrderSummaryPDFInBackground = async (orderId: number) => {
    try {
      const pdfResponse: string = await requestOrderSummaryPDF(orderId);
      if (pdfResponse) {
        setOrderData(prevOrderData => {
          if (!prevOrderData) return prevOrderData;
          return {
            ...prevOrderData,
            orderSummaryPDF: pdfResponse
          };
        });
      }
    } catch (error) {
      displayErrorNotification({ customJSXMessage: <>Error al obtener el PDF del resumen de la orden</> });
    }
  };

  /**
   * Obtiene los datos de la orden incluyendo productos y precios.
   */
  const getOrderData = async () => {
    setIsLoading(true);
    try {
      const response = await getOrderWithProductPrices(orderId);
      response.billingData =
        typeof response?.billingData === 'string' ? JSON.parse(response?.billingData) : response?.billingData;
      response.sales = response?.sales?.map(sale => ({
        ...sale,
        products: sale?.products as IProductInfo
      }));

      setOrderData(response);

      if (response?.id) {
        loadOrderSummaryPDFInBackground(response.id);
      }
    } catch (error) {
      displayErrorNotification({ customJSXMessage: <>Ocurrió un error al obtener los datos del pedido</> });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getOrderData();
  }, [state]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <ChargerModule
      infoSideBar={{ position: 'order' }}
      headerInfo={{ title: 'Edición de la orden', subtitle: `- N°${orderId}` }}
    >
      {isLoading ? (
        <div className="loadingContainer">
          <LoadingOutlined className="loadingSpinner" />
        </div>
      ) : orderData ? (
        <OrderPriceEditionModule orderData={orderData} />
      ) : null}
    </ChargerModule>
  );
};

export default OrderPriceEdition;
